/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CountResponse,
  DaysCountResponse,
  GetChartStatisticsReportChartGetParams,
  GetListStatisticsReportMetricsGetParams,
  GetListStatisticsReportRankGetParams,
  GetReportForGroupsReportGroupsGetParams,
  GetReportForStoriesReportStoriesGetParams,
  GetTodayStatisticsReportTodayGetParams,
  HTTPValidationError,
  ListResponse,
  MetricsResponse,
  RankResponse
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary GetChartStatistics
 */
export const getChartStatisticsReportChartGet = (
    params: GetChartStatisticsReportChartGetParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<DaysCountResponse>(
      {url: `/report/chart`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetChartStatisticsReportChartGetQueryKey = (params: GetChartStatisticsReportChartGetParams,) => {
    return [`/report/chart`, ...(params ? [params]: [])] as const;
    }

    
export const getGetChartStatisticsReportChartGetQueryOptions = <TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChartStatisticsReportChartGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>> = ({ signal }) => getChartStatisticsReportChartGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChartStatisticsReportChartGetQueryResult = NonNullable<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>>
export type GetChartStatisticsReportChartGetQueryError = HTTPValidationError


export function useGetChartStatisticsReportChartGet<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetChartStatisticsReportChartGet<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetChartStatisticsReportChartGet<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetChartStatistics
 */

export function useGetChartStatisticsReportChartGet<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetChartStatisticsReportChartGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChartStatisticsReportChartGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChartStatisticsReportChartGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>> = ({ signal }) => getChartStatisticsReportChartGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetChartStatisticsReportChartGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>>
export type GetChartStatisticsReportChartGetSuspenseQueryError = HTTPValidationError


export function useGetChartStatisticsReportChartGetSuspense<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetChartStatisticsReportChartGetSuspense<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetChartStatisticsReportChartGetSuspense<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetChartStatistics
 */

export function useGetChartStatisticsReportChartGetSuspense<TData = Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError = HTTPValidationError>(
 params: GetChartStatisticsReportChartGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChartStatisticsReportChartGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetChartStatisticsReportChartGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary GetListStatistics
 */
export const getListStatisticsReportRankGet = (
    params: GetListStatisticsReportRankGetParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<RankResponse>(
      {url: `/report/rank`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetListStatisticsReportRankGetQueryKey = (params: GetListStatisticsReportRankGetParams,) => {
    return [`/report/rank`, ...(params ? [params]: [])] as const;
    }

    
export const getGetListStatisticsReportRankGetQueryOptions = <TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListStatisticsReportRankGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>> = ({ signal }) => getListStatisticsReportRankGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListStatisticsReportRankGetQueryResult = NonNullable<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>>
export type GetListStatisticsReportRankGetQueryError = HTTPValidationError


export function useGetListStatisticsReportRankGet<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListStatisticsReportRankGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportRankGet<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListStatisticsReportRankGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportRankGet<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetListStatistics
 */

export function useGetListStatisticsReportRankGet<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListStatisticsReportRankGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetListStatisticsReportRankGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListStatisticsReportRankGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>> = ({ signal }) => getListStatisticsReportRankGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListStatisticsReportRankGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>>
export type GetListStatisticsReportRankGetSuspenseQueryError = HTTPValidationError


export function useGetListStatisticsReportRankGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportRankGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportRankGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetListStatistics
 */

export function useGetListStatisticsReportRankGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError = HTTPValidationError>(
 params: GetListStatisticsReportRankGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportRankGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListStatisticsReportRankGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary GetTodayStatistics
 */
export const getTodayStatisticsReportTodayGet = (
    params: GetTodayStatisticsReportTodayGetParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CountResponse>(
      {url: `/report/today`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTodayStatisticsReportTodayGetQueryKey = (params: GetTodayStatisticsReportTodayGetParams,) => {
    return [`/report/today`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTodayStatisticsReportTodayGetQueryOptions = <TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTodayStatisticsReportTodayGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>> = ({ signal }) => getTodayStatisticsReportTodayGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTodayStatisticsReportTodayGetQueryResult = NonNullable<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>>
export type GetTodayStatisticsReportTodayGetQueryError = HTTPValidationError


export function useGetTodayStatisticsReportTodayGet<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTodayStatisticsReportTodayGet<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTodayStatisticsReportTodayGet<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetTodayStatistics
 */

export function useGetTodayStatisticsReportTodayGet<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTodayStatisticsReportTodayGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTodayStatisticsReportTodayGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTodayStatisticsReportTodayGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>> = ({ signal }) => getTodayStatisticsReportTodayGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTodayStatisticsReportTodayGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>>
export type GetTodayStatisticsReportTodayGetSuspenseQueryError = HTTPValidationError


export function useGetTodayStatisticsReportTodayGetSuspense<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTodayStatisticsReportTodayGetSuspense<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetTodayStatisticsReportTodayGetSuspense<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetTodayStatistics
 */

export function useGetTodayStatisticsReportTodayGetSuspense<TData = Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError = HTTPValidationError>(
 params: GetTodayStatisticsReportTodayGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTodayStatisticsReportTodayGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTodayStatisticsReportTodayGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary GetListStatistics
 */
export const getListStatisticsReportMetricsGet = (
    params?: GetListStatisticsReportMetricsGetParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<MetricsResponse>(
      {url: `/report/metrics`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetListStatisticsReportMetricsGetQueryKey = (params?: GetListStatisticsReportMetricsGetParams,) => {
    return [`/report/metrics`, ...(params ? [params]: [])] as const;
    }

    
export const getGetListStatisticsReportMetricsGetQueryOptions = <TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListStatisticsReportMetricsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>> = ({ signal }) => getListStatisticsReportMetricsGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListStatisticsReportMetricsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>>
export type GetListStatisticsReportMetricsGetQueryError = HTTPValidationError


export function useGetListStatisticsReportMetricsGet<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetListStatisticsReportMetricsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportMetricsGet<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportMetricsGet<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetListStatistics
 */

export function useGetListStatisticsReportMetricsGet<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListStatisticsReportMetricsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetListStatisticsReportMetricsGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListStatisticsReportMetricsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>> = ({ signal }) => getListStatisticsReportMetricsGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetListStatisticsReportMetricsGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>>
export type GetListStatisticsReportMetricsGetSuspenseQueryError = HTTPValidationError


export function useGetListStatisticsReportMetricsGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetListStatisticsReportMetricsGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportMetricsGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetListStatisticsReportMetricsGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetListStatistics
 */

export function useGetListStatisticsReportMetricsGetSuspense<TData = Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError = HTTPValidationError>(
 params?: GetListStatisticsReportMetricsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getListStatisticsReportMetricsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetListStatisticsReportMetricsGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary GetReportForStories
 */
export const getReportForStoriesReportStoriesGet = (
    params?: GetReportForStoriesReportStoriesGetParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<ListResponse>(
      {url: `/report/stories`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetReportForStoriesReportStoriesGetQueryKey = (params?: GetReportForStoriesReportStoriesGetParams,) => {
    return [`/report/stories`, ...(params ? [params]: [])] as const;
    }

    
export const getGetReportForStoriesReportStoriesGetQueryOptions = <TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportForStoriesReportStoriesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>> = ({ signal }) => getReportForStoriesReportStoriesGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportForStoriesReportStoriesGetQueryResult = NonNullable<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>>
export type GetReportForStoriesReportStoriesGetQueryError = HTTPValidationError


export function useGetReportForStoriesReportStoriesGet<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params: undefined |  GetReportForStoriesReportStoriesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForStoriesReportStoriesGet<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForStoriesReportStoriesGet<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetReportForStories
 */

export function useGetReportForStoriesReportStoriesGet<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportForStoriesReportStoriesGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetReportForStoriesReportStoriesGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportForStoriesReportStoriesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>> = ({ signal }) => getReportForStoriesReportStoriesGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportForStoriesReportStoriesGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>>
export type GetReportForStoriesReportStoriesGetSuspenseQueryError = HTTPValidationError


export function useGetReportForStoriesReportStoriesGetSuspense<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params: undefined |  GetReportForStoriesReportStoriesGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForStoriesReportStoriesGetSuspense<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForStoriesReportStoriesGetSuspense<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetReportForStories
 */

export function useGetReportForStoriesReportStoriesGetSuspense<TData = Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError = HTTPValidationError>(
 params?: GetReportForStoriesReportStoriesGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForStoriesReportStoriesGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportForStoriesReportStoriesGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary GetReportForGroups
 */
export const getReportForGroupsReportGroupsGet = (
    params?: GetReportForGroupsReportGroupsGetParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<ListResponse>(
      {url: `/report/groups`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetReportForGroupsReportGroupsGetQueryKey = (params?: GetReportForGroupsReportGroupsGetParams,) => {
    return [`/report/groups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetReportForGroupsReportGroupsGetQueryOptions = <TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportForGroupsReportGroupsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>> = ({ signal }) => getReportForGroupsReportGroupsGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportForGroupsReportGroupsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>>
export type GetReportForGroupsReportGroupsGetQueryError = HTTPValidationError


export function useGetReportForGroupsReportGroupsGet<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetReportForGroupsReportGroupsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForGroupsReportGroupsGet<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForGroupsReportGroupsGet<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetReportForGroups
 */

export function useGetReportForGroupsReportGroupsGet<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportForGroupsReportGroupsGetQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetReportForGroupsReportGroupsGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportForGroupsReportGroupsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>> = ({ signal }) => getReportForGroupsReportGroupsGet(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReportForGroupsReportGroupsGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>>
export type GetReportForGroupsReportGroupsGetSuspenseQueryError = HTTPValidationError


export function useGetReportForGroupsReportGroupsGetSuspense<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetReportForGroupsReportGroupsGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForGroupsReportGroupsGetSuspense<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetReportForGroupsReportGroupsGetSuspense<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetReportForGroups
 */

export function useGetReportForGroupsReportGroupsGetSuspense<TData = Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError = HTTPValidationError>(
 params?: GetReportForGroupsReportGroupsGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReportForGroupsReportGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetReportForGroupsReportGroupsGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



